export class OrderServiceUpdate {
	id: string | undefined;
	packageId: string | undefined;
	issueDate: string | undefined;
	serviceId: string | undefined;
	confirmationNumber: string | undefined;
}
